import TextInput from "@mlb/react-patterns/dist/components/TextInput/textInput";
import { styledIcons, styledButtonIcons } from "@mlb/react-patterns/dist/components/TextInput/textInput.style";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import BREAKPOINTS from "@mlb/react-patterns/dist/style/breakpoints";
import styled from "styled-components";
import ListContainer, { ListContainerTypes } from "../ListContainer";
import { SelectFollowsTabsContainerContainer } from "../SelectFollowsTabsContainer/styles";
import SpinnerIndicator from "../Spinner";
export var SelectFollowsContainer = styled.div.withConfig({
  displayName: "styles__SelectFollowsContainer",
  componentId: "sc-xx1mmd-0"
})(["display:flex;flex-direction:column;padding-top:24px;", "{flex:1;height:0;}"], SelectFollowsTabsContainerContainer);
export var SearchInput = styled(TextInput).withConfig({
  displayName: "styles__SearchInput",
  componentId: "sc-xx1mmd-1"
})(["flex:none;height:auto;margin:0px 16px 24px;", ",", "{top:15px;}> input[type=\"search\"]{border-radius:10px;color:", ";font-size:16px;height:44px;&[data-focus-visible-added]{box-shadow:0 0 0 3px rgba(0,137,255,0.65);outline:none;}}"], styledIcons, styledButtonIcons, COLORS.mlbBlack);
export var SearchResults = styled(ListContainer).attrs({
  type: ListContainerTypes.FOLLOW
}).withConfig({
  displayName: "styles__SearchResults",
  componentId: "sc-xx1mmd-2"
})(["border-top:1px solid ", ";flex:1;height:0;overflow-x:hidden;overflow-y:auto;"], COLORS.mlbGrey2);
export var SpinnerContainer = styled.div.withConfig({
  displayName: "styles__SpinnerContainer",
  componentId: "sc-xx1mmd-3"
})(["border-top:1px solid ", ";flex:1;height:0;position:relative;", "{top:4rem;@media (min-width:", "){top:50%;}}"], COLORS.mlbGrey2, SpinnerIndicator, BREAKPOINTS.md);
export var NoResultsContainer = styled.div.withConfig({
  displayName: "styles__NoResultsContainer",
  componentId: "sc-xx1mmd-4"
})(["border-top:1px solid ", ";display:flex;flex:1;height:0;justify-content:center;padding:20px 40px;@media (min-width:", "){align-items:center;padding:40px;}"], COLORS.mlbGrey2, BREAKPOINTS.md);